module.exports = __webpack_public_path__ + "media/images/icon__profile@2x-d4f949f2bfce4655a02cfe776bc54bed.png";